import { render } from "./NewAlienPlayerForm.vue?vue&type=template&id=4cf21472&scoped=true"
import script from "./NewAlienPlayerForm.vue?vue&type=script&lang=js"
export * from "./NewAlienPlayerForm.vue?vue&type=script&lang=js"

import "./NewAlienPlayerForm.vue?vue&type=style&index=0&id=4cf21472&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf21472"]])

export default __exports__